import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import { get } from "helpers/api_helper";
import {
  GET_CONTACT_BY_ID,
  GET_ALL_VENDORS_LIGHT_API,
  GET_ALL_CUSTOMERS_LIGHT_API,
} from "constants/api_constants";
import {
  getAllCountries,
  getStatesForCountry,
  getCitiesForState,
} from "helpers/utils/locationUtil";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import { showErrorToast } from "helpers/toastMessages";
import secureLocalStorage from "react-secure-storage";
import * as api from "../../constants/api_constants";

// Custom spinner component
const LoadingSpinner = () => (
  <div className="spinner-border text-primary" role="status">
    <span className="sr-only">Loading...</span>
  </div>
);

function ViewContact() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [contact, setContact] = useState(null);
  console.log("contact",contact);
  
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [apiStatus, setApiStatus] = useState({ loading: false, error: null });

  const storedUser = secureLocalStorage.getItem("authUser");
  const user = JSON.parse(storedUser || "{}");

  // Fetch countries
  const fetchCountries = useCallback(async () => {
    try {
      setApiStatus((prev) => ({ ...prev, loading: true, error: null }));
      const fetchedCountries = getAllCountries();
      setCountries(fetchedCountries || []);
    } catch (error) {
      console.error("Fetch Countries Error:", error.message, error.stack);
      showErrorToast("Failed to load countries");
      setApiStatus((prev) => ({ ...prev, error: "Failed to load countries" }));
    } finally {
      setApiStatus((prev) => ({ ...prev, loading: false }));
    }
  }, []);

  // Fetch states
  const fetchStates = useCallback(async (countryCode) => {
    if (!countryCode) {
      setStates([]);
      return;
    }
    try {
      setApiStatus((prev) => ({ ...prev, loading: true, error: null }));
      const fetchedStates = getStatesForCountry(countryCode);
      setStates(fetchedStates || []);
    } catch (error) {
      console.error("Fetch States Error:", error.message, error.stack);
      showErrorToast("Failed to load states");
      setApiStatus((prev) => ({ ...prev, error: "Failed to load states" }));
      setStates([]);
    } finally {
      setApiStatus((prev) => ({ ...prev, loading: false }));
    }
  }, []);

  // Fetch cities
  const fetchCities = useCallback(async (countryCode, stateCode) => {
    if (!stateCode || !countryCode) {
      setCities([]);
      return;
    }
    try {
      setApiStatus((prev) => ({ ...prev, loading: true, error: null }));
      const fetchedCities = await getCitiesForState(countryCode, stateCode);
      setCities(fetchedCities || []);
    } catch (error) {
      console.error("Fetch Cities Error:", error.message, error.stack);
      showErrorToast("Failed to load cities");
      setApiStatus((prev) => ({ ...prev, error: "Failed to load cities" }));
      setCities([]);
    } finally {
      setApiStatus((prev) => ({ ...prev, loading: false }));
    }
  }, []);

  // Fetch vendors
  const fetchVendors = useCallback(async () => {
    try {
      setApiStatus((prev) => ({ ...prev, loading: true, error: null }));
      const response = await get(GET_ALL_VENDORS_LIGHT_API);
      console.log("Vendors API Response:", response);
      if (response && response.status && Array.isArray(response.data)) {
        const updatedData = response.data.map((item) => ({
          value: item.vendorId || "",
          label: item.companyName && item.companyName.trim() !== ""
            ? `${item.companyName.trim()} - (${item.vendorCode || "N/A"})`
            : `${item.email || item.vendorCode || "N/A"} - (${item.vendorCode || "N/A"})`,
          companyName: item.companyName || "",
        }));
        console.log("Formatted Vendors:", updatedData);
        setVendors(updatedData);
      } else {
        throw new Error("Invalid vendor response");
      }
    } catch (error) {
      console.error("Fetch Vendors Error:", error.message, error.stack);
      showErrorToast("Failed to load vendors");
      setApiStatus((prev) => ({ ...prev, error: "Failed to load vendors" }));
      setVendors([]);
    } finally {
      setApiStatus((prev) => ({ ...prev, loading: false }));
    }
  }, []);

  // Fetch customers
  const fetchCustomers = useCallback(async () => {
    try {
      setApiStatus((prev) => ({ ...prev, loading: true }));
      const response = await get(api.GET_ALL_CUSTOMERS_LIGHT_API);
      console.log("response", response);
      const updatedCustData = response.map((item) => ({
        value: item.customerId,
        label:
          item.companyName && item.companyName.trim() !== ""
            ? `${item.companyName.trim()} - (${item.customerCode})`
            : `${item.email || item.customerCode} - (${item.customerCode})`,
        companyName: item.companyName || "",
        primaryContactName: item.primaryContactName || "",
      }));
      console.log("Formatted Customers:", updatedCustData);
      setCustomers(updatedCustData);
    } catch (error) {
      console.error("Fetch Customers Error:", error);
      showErrorToast("CUSTOMERS FETCH FAIL");
    }
  }, []);

  // Fetch contact data
  const fetchContactData = useCallback(async () => {
  // debugger
    try {
      setApiStatus((prev) => ({ ...prev, loading: true, error: null }));
      const response = await get(api.GET_CONTACT_BY_ID(id));
      console.log("response",response);
      
      
        const contactData = response.data;
        const newContact = {
          contactId: String(contactData.id) || "",
          contactRelatedTo: contactData.contactRelatedTo?.toLowerCase() || "",
          customerName: contactData.customerName || "",
          customerId: String(contactData.customerId) || "",
          vendorName: contactData.vendorName || "",
          vendorId: String(contactData.vendorId) || "",
          firstName: contactData.firstName || "",
          lastName: contactData.lastName || "",
          department: contactData.department || "",
          designation: contactData.designation || "",
          primaryContact: contactData.primaryContact === "YES" ? true : false,
          status: contactData.status === 1 ? "active" : "inactive",
          contactType: contactData.contactType || "",
          notes: contactData.notes || "",
          createdBy: contactData.createdBy || user?.email || "unknown",
          createdDate: contactData.createdDate || "",
          updatedDate: contactData.updatedDate || "",
          email: contactData.email || "",
          mobile: contactData.phoneNumber || "",
          landline: contactData.landLine || "",
          linkedIn: contactData.linkedInUrl || "",
          country: contactData.country || "",
          province: contactData.province || "",
          city: contactData.city || "",
          postalCode: String(contactData.postalCode) || "",
          address: contactData.address || "",
        };
        setContact(newContact);
        if (contactData.country) {
          await fetchStates(contactData.country);
          if (contactData.province) {
            await fetchCities(contactData.country, contactData.province);
          }
        }
     
    } catch (error) {
      console.error("Fetch Contact Error:", error.message, error.stack);
      showErrorToast(error.message || "Failed to load contact data");
      setApiStatus((prev) => ({
        ...prev,
        error: error.message || "Failed to load contact data",
      }));
    } finally {
      setApiStatus((prev) => ({ ...prev, loading: false }));
    }
  }, [id, user?.email, fetchStates, fetchCities, navigate]);

  useEffect(() => {
    if (!id) {
      showErrorToast("No contact ID provided");
      setApiStatus((prev) => ({ ...prev, error: "No contact ID provided" }));
      navigate("/contacts");
      return;
    }
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchCountries(),
          fetchVendors(),
          fetchCustomers(),
          fetchContactData(),
        ]);
      } catch (error) {
        console.error(
          "Error in initial data fetch:",
          error.message,
          error.stack
        );
      }
    };
    fetchData();
  }, [fetchCountries, fetchVendors, fetchCustomers, fetchContactData, id]);

  // Get display values for dropdowns
  const getCountryLabel = (value) =>
    countries.find((c) => c.value === value)?.label || value || "";
  const getStateLabel = (value) =>
    states.find((s) => s.value === value)?.label || value || "";
  const getCityLabel = (value) =>
    cities.find((c) => c.value === value)?.label || value || "";
  const getCustomerName = (customerId) => {
    const selectedCustomer = customers.find((c) => c.value == (customerId));
    console.log("Selected Customer for ID", customerId, ":", selectedCustomer);
    return selectedCustomer?.companyName || contact?.customerName || "asnas";
  };
  const getVendorName = (vendorId) =>
    vendors.find((v) => v.vendorId == (vendorId))?.companyName ||
    contact?.vendorName ||
    "";

  // Handle back button
  const handleBack = () => {
    navigate("/contacts");
  };

  // Render error state
  // if (apiStatus.error && !contact) {
  //   return (
  //     <div className="page-content">
  //       <Container fluid style={{ padding: "0px", gap: "10px" }}>
  //         <PageSubHeader
  //           heading="View Contact"
  //           routePath="Home"
  //           pageName="Contacts"
  //           backPath="/contacts"
  //         />
  //         <Row className="p-4">
  //           <Col>
  //             <Card>
  //               <CardBody>
  //                 <div className="text-center my-3">
  //                   <p className="text-danger">{apiStatus.error}</p>
  //                   <button className="btn btn-primary" onClick={handleBack}>
  //                     Back to Contacts
  //                   </button>
  //                 </div>
  //               </CardBody>
  //             </Card>
  //           </Col>
  //         </Row>
  //       </Container>
  //     </div>
  //   );
  // }

  return (
    <div className="page-content">
      <Container fluid style={{ padding: "0px", gap: "10px" }}>
        <PageSubHeader
          heading="View Contact"
          routePath="Home"
          pageName="Contacts"
          backPath="/contacts"
        />
        <Row className="p-4">
          <Col>
            <Card>
              <CardBody>
                {apiStatus.loading && (
                  <div className="text-center my-3">
                    <LoadingSpinner />
                  </div>
                )}
                {!apiStatus.loading && contact && (
                  <Form className="row g-3 needs-validation py-4">
                    {/* Basic Information */}
                    <Row className="card-group">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Basic Information</p>
                      </Col>
                      <Row className="card-group-body">
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="contactRelatedTo">
                              Contact Related To
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="contactRelatedTo"
                              value={contact.contactRelatedTo || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        {contact.contactRelatedTo === "customer" && (
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label htmlFor="customerName">
                                Customer Name
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="customerName"
                                value={getCustomerName(contact.customerId)}
                                disabled
                              />
                            </FormGroup>
                          </Col>
                        )}
                        {contact.contactRelatedTo === "vendor" && (
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label htmlFor="vendorName">Vendor Name</Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="vendorName"
                                value={getVendorName(contact.vendorId)}
                                disabled
                              />
                            </FormGroup>
                          </Col>
                        )}
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="contactId">Contact ID</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="contactId"
                              value={contact.contactId || "Auto-generated"}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="firstName">First Name</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="firstName"
                              value={contact.firstName || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="lastName">Last Name</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="lastName"
                              value={contact.lastName || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="department">Department</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="department"
                              value={contact.department || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="designation">Designation</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="designation"
                              value={contact.designation || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="primaryContact">
                              Primary Contact
                            </Label>
                            <Input
                              type="checkbox"
                              className="form-check-input"
                              id="primaryContact"
                              checked={contact.primaryContact}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="status">Status</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="status"
                              value={contact.status || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="contactType">Contact Type</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="contactType"
                              value={contact.contactType || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="notes">Notes</Label>
                            <Input
                              type="textarea"
                              className="form-control"
                              id="notes"
                              value={contact.notes || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Row>

                    {/* Contact Details */}
                    <Row className="card-group mt-4">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Contact Details</p>
                      </Col>
                      <Row className="card-group-body">
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="email">Email Address</Label>
                            <Input
                              type="email"
                              className="form-control"
                              id="email"
                              value={contact.email || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="mobile">
                              Phone Number (Mobile)
                            </Label>
                            <PhoneInput
                              international
                              defaultCountry="IN"
                              id="mobile"
                              className="form-control d-flex"
                              value={contact.mobile || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="landline">
                              Phone Number (Landline)
                            </Label>
                            <PhoneInput
                              international
                              defaultCountry="IN"
                              id="landline"
                              className="form-control d-flex"
                              value={contact.landline || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="linkedIn">
                              LinkedIn Profile URL
                            </Label>
                            <Input
                              type="url"
                              className="form-control"
                              id="linkedIn"
                              value={contact.linkedIn || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Row>

                    {/* Communication Address */}
                    <Row className="card-group mt-4">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Communication Address</p>
                      </Col>
                      <Row className="card-group-body">
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="country">Country</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="country"
                              value={getCountryLabel(contact.country) || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="province">Province</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="province"
                              value={getStateLabel(contact.province) || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="city">City</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="city"
                              value={getCityLabel(contact.city) || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="postalCode">Postal Code</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="postalCode"
                              value={contact.postalCode || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup className="mb-3">
                            <Label htmlFor="address">Address</Label>
                            <Input
                              type="textarea"
                              className="form-control"
                              id="address"
                              value={contact.address || ""}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Row>
                  </Form>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Footer
          saveText="Edit contact"
        save={() => navigate(`/add-contact/${id}`)}
        />
      </Container>
    </div>
  );
}

export default ViewContact;
